// NOTE(dmac) This file is a canary for a user having an ad blocker enabled when using skipper. If one is
// enabled, this file will be blocked due to its name and we display a warning message.
// NOTE(stefan): This is a duplicate of ads.js in skipper
window.ads_can_show = true;
